import { DsNotifier } from "../helpers";
import { useDsApiStore, useDsSystemNotifierStore } from "../stores";
import { storeToRefs } from "pinia";

export const useDsMaintenance = () => {
  const { setMaintenanceOn, setMaintenanceOff } = useDsApiStore();
  const { setMaintenanceId } = useDsSystemNotifierStore();
  const { maintenanceNotificationId } = storeToRefs(useDsSystemNotifierStore());

  const setOn = (message: string) => {
    setMaintenanceOn();
    if (maintenanceNotificationId.value === 0) {
      const id = DsNotifier.sendInfo({
        message,
        duration: 0,
        enableClose: false,
        position: "top-0 right-0",
        overlay: true,
      });
      setMaintenanceId(id);
    }
  };

  const setOff = () => {
    setMaintenanceOff();
    DsNotifier.delete(maintenanceNotificationId.value);
    setMaintenanceId(0);
  };

  return {
    setOn,
    setOff,
  };
};
